import React from 'react'
import { Spinner } from '../../ui/spinner/spinner'

import './loading.css'

const Loading = () => {
  return (
    <main className="loading">
      <Spinner />
    </main>
  )
}

export default Loading
